import React from 'react';

const Bg2Icon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="435"
      height="223"
      fill="none"
      viewBox="0 0 435 223"
    >
      <path
        stroke="url(#paint0_linear_1317_4992)"
        strokeWidth="53"
        d="M401.404 134.121c13.611 49.239 4.652 90.847-19.789 124.051-24.99 33.95-67.886 61.312-125.416 76.881-49.623 13.429-99.87 11.889-140.175-4.411-39.544-15.993-70.337-46.366-83.462-93.844C8.706 150.497 71.31 63.313 176.134 34.946c99.962-27.053 201.907 14.661 225.27 99.175z"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1317_4992"
          x1="168.368"
          x2="231.004"
          y1="9.594"
          y2="451.322"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B2EFE5"/>
          <stop offset="1" stopColor="#B2EFE5" stopOpacity="0"/>
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Bg2Icon;
